import Icon from "../../../components/base/Icon"
import { ChatEnvironments } from "../../../core/Enums"
import ChatContactItem from "../models/ChatContactItem"


interface IProps {
    item?: ChatContactItem
    size?: number
    classNames?: string
}
export default function ChatAvatarSpan(props: IProps) {

    // Our own chat with the account wears our own mark rather than a letter or a building.
    const isRinvox = props.item?.systemKey === "rinvox"

    const classNames = () => {
        var cls = "symbol-label fw-bolder ";

        if (isRinvox) cls += "bg-white";
        else if (props.item?.isGroup) cls += "bg-light-info text-info";
        else if (props.item?.tech) cls += "bg-light-danger text-danger";
        else cls += "bg-light-success text-success"



        if (props.classNames) cls += " " + props.classNames;

        return cls;
    }


    return (
        <span className={classNames()}>
            {
                isRinvox
                    ? <img src="/icons/icon-192.png" alt="Rinvox"
                        style={{ width: (props.size ?? 18) + 6, height: (props.size ?? 18) + 6 }} />
                    : props.item?.isSystem ? <Icon icon="building" size={props.size ?? 18} />
                    : props.item?.isGroup ? <Icon icon="user-group" size={props.size ?? 18} />
                        : props.item?.tech ? <Icon icon="user-helmet-safety" size={props.size ?? 18} />
                            : <Icon icon="mobile-retro" size={props.size ?? 18} />
            }
        </span>
    )
}